import { FunctionColor } from '@lux/core';
import styled from 'styled-components';

export const TabsContainer = styled.div<{ isBrazeSnackbar: boolean }>`
    position: relative;
    z-index: -1;

    background: ${p => (p.isBrazeSnackbar ? 'rgba(255, 255, 255, 0.0)' : FunctionColor.function0)};
    border-bottom: 1px solid ${FunctionColor.function20};

    .transition__group {
        position: absolute;
        right: 0;
        left: 0;
    }

    .flash_messages,
    .notifications {
        position: absolute;
        top: 0px;
    }

    .tabs__wrapper {
        .grid-row {
            button span {
                text-transform: uppercase;
            }
            button[aria-selected='true'] {
                border-bottom: 2px solid #000;
                span {
                    font-weight: 700;
                }
            }
        }
    }
`;

export const HeaderWrap = styled.div<{ movePositionTopBy: number }>`
    position: sticky;
    top: ${({ movePositionTopBy }) => `${movePositionTopBy}px`};
    width: 100%;
    z-index: 2023;
`;

export const HeaderRowsHolder = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderBannerRow = styled.div<{ height?: number | 'auto' }>`
    height: ${({ height = 60 }) => (height === 'auto' ? 'auto' : `${height}px`)};
    transform: translate(0, 0);
    .flash_messages {
        position: static;
    }
`;
